import api from "@/api/viktor"
import type { NextAssessment } from "@/types/next-assessment"

export async function getNextAssessment(
  uuid?: string,
  retake?: boolean
): Promise<NextAssessment> {
  const params = new URLSearchParams()
  if (uuid) params.set("workflow_user_uuid", uuid)
  if (retake) params.set("retake", "true")

  const query = params.toString()
  const path = `/me/next-assessment${query ? `?${query}` : ""}`

  const response = await api({
    method: "GET",
    url: path,
  })

  return response
}
